<div class="py-3 min-w-224">
  <div class="text-right">
    <span class="cursor-pointer" (click)="dialogRef.close()"><strong>X</strong></span>
  </div>
  <div class="mt-4">
    <div class="text-center">
      <app-responsive-video [videoURL]="data.data.videoURL"></app-responsive-video>
    </div>
  </div>
</div>
